export function convertGramToKilogram (valueInGrams) {
  return valueInGrams / 1000;
};
